import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

interface Props {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DisconnectTrustapAccountPopup: React.FC<Props> = ({
  show,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="confirmModal"
    >
      <Modal.Body>
        <div className="confirmModal__icon confirmModal__icon--danger">
          <i className="bi bi-link-45deg" aria-hidden="true" />
        </div>
        <h2 className="confirmModal__title">Disconnect Trustap account?</h2>
        <p className="confirmModal__subtitle">
          This clears the link on our side so you can re-run the Trustap
          connection. Useful when scopes change and `track` or
          `claim_for_seller` start returning <strong>401</strong>.
        </p>

        <div className="confirmModal__details">
          <div className="confirmModal__detailRow">
            <i className="bi bi-shield-check" aria-hidden="true" />
            <span>
              Your guest user info is <strong>preserved</strong> — any
              in-flight transactions bound to the guest seller_id are
              unaffected.
            </span>
          </div>
          <div className="confirmModal__detailRow">
            <i className="bi bi-arrow-counterclockwise" aria-hidden="true" />
            <span>
              You'll need to click <strong>Get started</strong> again to
              reconnect. Trustap may auto-approve if your SSO session is
              still active — log out at sso.trustap.com first to force a
              fresh consent screen.
            </span>
          </div>
          <div className="confirmModal__detailRow">
            <i className="bi bi-info-circle" aria-hidden="true" />
            <span>
              Until you reconnect, you won't be able to claim payouts or
              push tracking on new sales.
            </span>
          </div>
        </div>

        <div className="confirmModal__footer">
          <Button className="closeBtn" variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <button
            type="button"
            className="confirmModal__danger"
            onClick={onConfirm}
          >
            Disconnect
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DisconnectTrustapAccountPopup;
